import React, { Dispatch, SetStateAction } from 'react';
import { JobPostingPreview } from '../../Preview';
import UnifiedActions from './UnifiedActions';
import { JobPostingTabData } from '../../../../../../../utils/types/JobOpenings';

interface PreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  jobPostingData: JobPostingTabData;
  resolvedPostId?: string;
  liveHtml: string;
  isSaving: boolean;
  onSaveOrCreate: () => void;
  setJobPostId: Dispatch<SetStateAction<string>>;
  setStages: (value: any) => void;
}

export const PreviewModal = ({
  isOpen,
  onClose,
  jobPostingData,
  resolvedPostId,
  liveHtml,
  isSaving,
  onSaveOrCreate,
  setJobPostId,
  setStages,
}: PreviewModalProps) => {
  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4 animate-fade-in'>
      <div className='relative w-full max-w-5xl max-h-[90vh] bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden animate-scale-up'>
        <div className='px-6 py-4 border-b border-slate-100 flex items-center justify-between bg-white'>
          <h2 className='text-lg font-bold text-slate-900'>Public Job Post Preview</h2>
          <button
              onClick={onClose}
              className='text-slate-400 hover:text-slate-600 transition-colors p-1.5 hover:bg-slate-100 rounded-lg'
          >
            <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
            </svg>
          </button>
        </div>
        <div className='flex-1 overflow-y-auto bg-slate-50'>
          <JobPostingPreview
              jobPostingData={jobPostingData}
              jobPostId={resolvedPostId ?? ''}
              setJobPostId={setJobPostId}
              setStages={setStages}
              liveHtml={liveHtml}
              hidePublishBanner={true}
          />
        </div>
        {/* Modal Bottom Action Banner */}
        <div className='border-t border-slate-150 p-4 bg-white shadow-md'>
          <UnifiedActions
              resolvedPostId={resolvedPostId}
              isSaving={isSaving}
              jobPostingData={jobPostingData}
              onSaveOrCreate={onSaveOrCreate}
          />
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;
